module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-80\">Axes Type</label> \r\n        <div>\r\n            <select name=\"lineChartType\" id=\"lineChartType\" >\r\n                <option value=\"segment\">Segment</option>\r\n                <option value=\"curve\">Curve</option>\r\n                <option value=\"horizontal\">Horizontal</option>\r\n                <option value=\"vertical\">Vertical</option>\r\n                <option value=\"step\">Step</option>\r\n                <option value=\"reverseStep\">Step reversed</option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}